/**
 * It creates a cache object that can be used to store styles
 * @returns A function that returns a cache object.
 */
import createCache from '@emotion/cache';

export const createEmotionCache = () => {
  return createCache({ key: 'css' });
};
